import { DatePipe } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { DateAdapter } from "@angular/material/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { VendorOptions } from "app/_models/optionsList/options";
import { PurchaseOrders } from "app/_models/purchaseOrders/purchase-orders";
import { UserModel } from "app/_models/user-model";
import { CrudPurchaseOrderService } from "app/_services/MasterCrudOps/crud-purchase-order.service";
import { OptionslistService } from "app/_services/optionslist.service";
import { UiActionUtils } from "app/shared/utils/ui-action-utils";
@Component({
  selector: "app-edit-purchase-order",
  templateUrl: "./edit-purchase-order.component.html",
  styleUrls: ["./edit-purchase-order.component.css"],
})
export class EditPurchaseOrderComponent implements OnInit {
  editPurchaseOrderForm: UntypedFormGroup | null = null;
  editOrder: PurchaseOrders;
  vendorOptions: VendorOptions[] = [];
  today: Date;
  pageNumber: number;
  pageSize: number;
  isLoaderResult: boolean = false;
  currentUser: UserModel;
  isAdminGroupUser: boolean = false;

  constructor(
    public readonly datepipe: DatePipe,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly purchaseOrderService: CrudPurchaseOrderService,
    private readonly optionslistService: OptionslistService,
    private readonly dialogRef: MatDialogRef<EditPurchaseOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dateAdapter: DateAdapter<Date>
  ) {
    this.dateAdapter.setLocale("en-GB");
    this.editOrder = data.editPoOrder;
    console.log(JSON.stringify(this.editOrder));
    this.pageNumber = data.pageNumber;
    this.pageSize = data.pageSize;
    this.today = new Date();
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    this.isAdminGroupUser = this.currentUser.isAdminGroupUser;
  }

  ngOnInit(): void {
    this.editPurchaseOrderForm = this.formBuilder.group({
      vendorCode: new UntypedFormControl(null, [Validators.required]),
      orderDate: new UntypedFormControl(null, [Validators.required]),
      description: new UntypedFormControl("", [
        Validators.required,
        Validators.maxLength(100),
      ]),
      address: new UntypedFormControl("", [
        Validators.required,
        Validators.maxLength(250),
      ]),
    });

    this.getVendorData();

    // Patch form with existing values
    this.editPurchaseOrderForm.patchValue({
      vendorCode: this.editOrder.vendorCode ?? null,
      orderDate: this.editOrder.orderDate
        ? new Date(this.editOrder.orderDate)
        : null,
      description: this.editOrder.description ?? "",
      address: this.editOrder.address ?? "",
    });
  }

  getVendorData() {
    this.optionslistService.getVendorOptions().subscribe((data) => {
      this.vendorOptions = data;
    });
  }

  updatePurchaseOrder() {
    UiActionUtils.confirmUpdate("You won't be able to revert this!", () => {
      this.updatePurchaseOrderDetail();
    });
  }

  updatePurchaseOrderDetail(): void {
    this.isLoaderResult = true;
    let model = {
      purchaseOrderId: this.editOrder.findiPurchaseOrderId,
      erpPoNumber: this.editOrder.poNumber,
      orderDate: this.datepipe.transform(
        this.editOrder.orderDate,
        "yyyy-MM-dd"
      ),
      vendorCode: this.editOrder.vendorCode,
      address: this.editOrder.address,
      description: this.editOrder.description,
    };

    this.purchaseOrderService.updatePurchaseOrder(model).subscribe(
      (data) => {
         this.isLoaderResult = false;
        if (data.didError) {
          UiActionUtils.showError(data.message, data.additionalMessage);
        } else {
          UiActionUtils.showSuccess(data.message);
          let result = {
            status: true,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          };
          this.dialogRef.close(result);
        }
      },
      (err) => {
        UiActionUtils.showError("Something went wrong", err.message);
        this.isLoaderResult = false;
      }
    );
  }

  onDateChange(e) {
    this.editOrder.orderDate = e.value;
  }

  close() {
    let result = {
      status: false,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
    };
    this.dialogRef.close(result);
  }
}
